import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EmopTableProClass } from '../../class/EmopTableProClass/EmopTableProClass';
import { EmopFormProClass } from '../../class/EmopFormProClass/EmopFormProClass';

@Injectable({
  providedIn: 'root'
})

export class EmopPublicWorkflowApprovalService {
  showForm: boolean;
  processInstanceId: string; // 当前流程id
  processNodeId: string; // 当前流程中的节点id
  onApprovalTableClick: Function; // 审批对象被点击的行事件
  // 审批对象的表格
  approvalObjectTable = new EmopTableProClass({
    header: [],
    data: [],
    mode: 'normal',
    pageInfo: {
      size: 'small',
      showQuickJumper: false
    }
  });
  // 审批记录的表格
  recordTable = new EmopTableProClass({
    header: [
      {
        alias: '流程节点',
        key: 'activityName',
      },
      {
        alias: '是否处理',
        key: 'code',
        width: '100px'
      },
      {
        alias: '处理人',
        key: 'assigneeName'
      },
      {
        alias: '处理时间',
        key: 'code'
      },
      {
        alias: '审批意见',
        key: 'code'
      }
    ],
    data: [],
    mode: 'normal',
    pageInfo: {
      size: 'small',
      showQuickJumper: false
    }
  });
  // 审批表单里的表单schema数据
  formData = new EmopFormProClass([]);
  submitLoading = false;
  constructor(
    private http: HttpClient
  ) { }
}
